if (!customElements.get('feature-details')) {
    customElements.define(
        'feature-details',
        class featureDetails extends HTMLElement {
            constructor() {
            super();

            this.initialiseModals()

            this.player = {}
            }
            initialiseModals () {
                const modal = getElement('[data-el="featured-image.modal"]', { context: this });
                if(modal == null){return}
                const modalClose = getElement('[data-el="featured-image.modalclose"]', { context: this });
                const modalbuttonEl = getElement('[data-el="featured-image.modalbutton"]', { context: this });
                modal.addEventListener('click', e => {
                    if (e.target !== modal) return
                    const video = getElement('iframe', { context: modal })
                    modal.setAttribute('aria-expanded', false)
                    if (video) {
                    this.player.pause()
                    }
                })
                modalbuttonEl.addEventListener('click', () => {
                const video = getElement('iframe', { context: modal })
                const newSrc = video.getAttribute('data-src');
                video.src = newSrc;
                modal.setAttribute('aria-expanded', true)
                const shouldAutoplay = modal.querySelector('.mod-Modal_Content').setAttribute('data-insert-video-autoplay','true');
                if (!shouldAutoplay) return
                this.initialiseVimeoApi(modal)
                setTimeout(() => {
                    this.player.play()
                }, 500)
                })

                modalClose.addEventListener('click', () => {
                const video = getElement('iframe', { context: modal })
                modal.setAttribute('aria-expanded', false)
                if (video) {
                    this.player.pause()
                }
                })
            }
            initialiseVimeoApi(modal){
                const vimeoApiUrl = 'https://player.vimeo.com/api/player.js'
                const vimeoScriptExists = getElement(`script[src="${vimeoApiUrl}"]`)
            
                if (vimeoScriptExists) return
                const vimeoApiScript = createElement('script', { src: vimeoApiUrl })
                document.head.appendChild(vimeoApiScript)
            
                setTimeout(() => {
                const iframe = modal.querySelector('iframe')
                this.player = new window.Vimeo.Player(iframe)
                }, 500)
            }
        }
    );
}